/**
 * Alinhado com intrapaf-v2-administration `assets/js/config/vueSanitizeOptions.ts`.
 * Vue3Sanitize + $sanitizePost usam este objeto.
 */
export const vueSanitizeOptions = {
  allowedTags: [
    "address",
    "article",
    "aside",
    "footer",
    "header",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "hgroup",
    "main",
    "nav",
    "section",
    "blockquote",
    "dd",
    "div",
    "dl",
    "dt",
    "figcaption",
    "figure",
    "hr",
    "li",
    "main",
    "ol",
    "p",
    "pre",
    "ul",
    "a",
    "abbr",
    "b",
    "bdi",
    "bdo",
    "br",
    "cite",
    "code",
    "data",
    "dfn",
    "em",
    "i",
    "kbd",
    "mark",
    "q",
    "rb",
    "rp",
    "rt",
    "rtc",
    "ruby",
    "s",
    "samp",
    "small",
    "span",
    "strong",
    "sub",
    "sup",
    "time",
    "u",
    "var",
    "wbr",
    "caption",
    "col",
    "colgroup",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "tr",
    "iframe",
  ],
  allowedAttributes: {
    a: ["href", "name", "target"],
    iframe: ["src", "frameborder", "allowfullscreen"],
    img: ["src", "srcset", "alt", "title", "width", "height", "loading"],
    div: ["class"],
    p: ["class"],
    ul: ["class"],
    li: ["class"],
    hr: ["class"],
  },
  allowedClasses: {
    div: ["ask-doc-msg", "ask-doc-msg__section"],
    p: [
      "ask-doc-msg__text",
      "ask-doc-msg__title",
      "ask-doc-msg__thanks",
      "ask-doc-msg__footer",
    ],
    ul: ["ask-doc-msg__list"],
    li: [
      "ask-doc-msg__item",
      "ask-doc-msg__item--ok",
      "ask-doc-msg__item--missing",
    ],
    hr: ["ask-doc-msg__sep"],
  },
  allowedIframeHostnames: ["www.youtube.com"],
};
